import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormErrorsPipe } from './pipes/form-errors.pipe';

@NgModule({
    declarations: [FormErrorsPipe],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormErrorsPipe
    ]
})
export class SharedModule
{
}
